import React from 'react';
import PastPaperManagement from '../../components/SuperAdmin/PastPaperManagement';

const PastPapersManagementPage: React.FC = () => {
  return <PastPaperManagement />;
};

export default PastPapersManagementPage;
